import Vue from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import routes from './routes'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueResource)

// Vue.http.options.root = 'http://127.0.0.1:3000/'
Vue.http.options.xhr = { withCredentials: true };
Vue.http.options.emulateJSON = true

const router = new VueRouter({
  routes: routes,
  mode: 'history'
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
